export default "__VITE_ASSET__d278b212__"